<template>
    <ul class="list-reset flex uppercase py-6 pl-6 sans">
        <li class="mr-6">
            <router-link :to="toLanding" class="inline-block rounded py-4 px-4 bg-grey-darker text-white no-underline">Home</router-link>
        </li>
        <li v-if="grandparent" class="mr-6">
            <router-link :to="grandparent.uri" class="inline-block rounded py-4 px-4 bg-grey-darker text-white no-underline">{{ grandparent.title }}</router-link>
        </li>
        <li v-if="parent" class="mr-6 flex">
            <a class="inline-block font-bold text-white no-underline text-3xl self-center sans-bd" href="#">{{ parent.title }}</a>
        </li>
    </ul>
</template>
<script>
export default {
  name: 'nav-breadcrumb',
  props: ['parent', 'grandparent'],

  computed: {

    toLanding () {
      return {
        name: 'home'
      }
    }
  }
}
</script>
